// const backendDomain = "https://demo.oakyaitservices.in/api";

const backendDomain = "https://siddhiganapathi.com/";

const SummaryApi = {
  popupForm: {
    url: `${backendDomain}/mail/mailsend1.php`,
    method: "post",
  },
};

export default SummaryApi;
